import { Controller } from "@hotwired/stimulus"

// Tencent Captcha Stimulus Controller
// Documentation: https://cloud.tencent.com/document/product/1110/36841
//
// Usage:
// <button data-controller="tencent-captcha"
//         data-tencent-captcha-app-id-value="your_app_id"
//         data-action="click->tencent-captcha#verify">
//   Verify
// </button>
//
// Events:
// - captcha:verified - dispatched when verification succeeds, detail: { ticket, randstr }
// - captcha:error - dispatched when verification fails or user cancels

export default class extends Controller {
  static values = {
    appId: String
  }

  connect() {
    this.loadScript()
  }

  loadScript() {
    if (window.TencentCaptcha) return

    const script = document.createElement('script')
    script.src = 'https://turing.captcha.qcloud.com/TJCaptcha.js'
    script.async = true
    document.head.appendChild(script)
  }

  verify(event) {
    event.preventDefault()

    if (!window.TencentCaptcha) {
      console.error('TencentCaptcha script not loaded')
      this.dispatchError('script_not_loaded', 'Captcha script not loaded')
      return
    }

    if (!this.appIdValue) {
      console.error('TencentCaptcha appId not configured')
      this.dispatchError('not_configured', 'Captcha not configured')
      return
    }

    const captcha = new window.TencentCaptcha(
      this.appIdValue,
      (res) => this.handleCallback(res),
      { needFeedBack: false }
    )

    captcha.show()
  }

  handleCallback(res) {
    // res.ret: 0 = success, 2 = user closed
    if (res.ret === 0) {
      this.dispatchVerified(res.ticket, res.randstr)
    } else if (res.ret === 2) {
      this.dispatchError('user_cancelled', 'User cancelled verification')
    } else {
      this.dispatchError(res.errorCode, res.errorMessage)
    }
  }

  dispatchVerified(ticket, randstr) {
    const event = new CustomEvent('captcha:verified', {
      bubbles: true,
      detail: { ticket, randstr }
    })
    this.element.dispatchEvent(event)
  }

  dispatchError(errorCode, errorMessage) {
    const event = new CustomEvent('captcha:error', {
      bubbles: true,
      detail: { errorCode, errorMessage }
    })
    this.element.dispatchEvent(event)
  }
}
